import { getCookie, setCookie } from './helpers_function'

class Layout {
  constructor() {
    this.DOM = {
      searchforms: document.querySelectorAll('.js-form-search'),
      contrastButtons: document.querySelectorAll('.js-contrast'),
      body: document.querySelector('.js-body'),
      root: document.querySelector(':root'),
      fontChangerButtons: document.querySelectorAll('.js-font-size'),
      cookies: document.querySelector('.js-cookies'),
    }
    this.fontSize = 16
  }

  init() {
    this.searchformsAction()
    this.contrastAction()
    this.fontChangerAction()

    if (this.DOM.cookies) {
      this.cookies()
    }

    const fontSize = getCookie('fontSize')
    if (fontSize) {
      this.fontSize = fontSize
      this.DOM.root.style.fontsize = `${fontSize}px`
    }

    const contrast = getCookie('contrast')
    if (contrast === '1') {
      this.DOM.body.classList.add('contrast')
    }
  }

  cookies() {
    const accept = this.DOM.cookies.querySelector('.js-cookies-accept')
    accept.addEventListener('click', () => {
      this.DOM.cookies.classList.add('cookie-hide')
      setCookie('cookie_nid_konserwator', 'set', 183)
    })
  }

  fontChangerAction() {
    this.DOM.fontChangerButtons.forEach((el) => {
      el.addEventListener('click', () => {
        if (this.fontSize < 20) {
          this.fontSize = Number(this.fontSize) + 2
        } else {
          this.fontSize = 12
        }
        this.DOM.root.style.fontSize = `${this.fontSize}px`
        setCookie('fontSize', this.fontSize, 7)
      })
    })
  }

  contrastAction() {
    this.DOM.contrastButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this.DOM.body.classList.toggle('contrast')
        const contrast = getCookie('contrast')
        if (contrast === '1') {
          setCookie('contrast', '0', 7)
        } else {
          setCookie('contrast', '1', 7)
        }
      })
    })
  }

  searchformsAction() {
    this.DOM.searchforms.forEach((el) => {
      el.addEventListener('submit', (e) => {
        e.preventDefault()
        const input = el.querySelector('input')
        if (input.value === '') {
          input.focus()
          return false
        }
        el.submit()
        return true
      })
    })
  }
}

export default Layout
